// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customcard[data-v-15e17984]{box-shadow:0 1px 3px rgba(0,0,0,.12),0 -1px 5px rgba(0,0,0,.24);border:0}", ""]);
// Exports
module.exports = exports;
